var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isProfileEnhancementEnabled)?_c('deposit-redesign',_vm._g(_vm._b({},'deposit-redesign',_vm.$attrs,false),_vm.$listeners)):_c('deposit-legacy',_vm._g(_vm._b({},'deposit-legacy',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }